import React from "react";
import {
  Pagination,
  PaginationContent,
  PaginationItem,
  PaginationLink,
  PaginationNext,
  PaginationPrevious,
} from "../ui/pagination";
function PaginationComponent({ pagination, onPageChange }) {
  const { current_page, last_page } = pagination;

  const pages = [];
  for (let i = 1; i <= last_page; i++) {
    pages.push(i);
  }

  return (
    <Pagination>
      <PaginationContent>
        {/* السابق */}
        <PaginationItem className={"cursor-pointer"}>
          <PaginationPrevious
            href="#"
            onClick={(e) => {
              e.preventDefault();
              if (current_page > 1) onPageChange(current_page - 1);
            }}
          />
        </PaginationItem>

        {/* أرقام الصفحات */}
        {pages.map((page) => (
          <PaginationItem  key={page}>
            <PaginationLink
            className={"cursor-pointer"}
              isActive={page === current_page}
              onClick={(e) => {
                e.preventDefault();
                onPageChange(page);
              }}
            >
              {page}
            </PaginationLink>
          </PaginationItem>
        ))}

        {/* التالي */}
        <PaginationItem className={"cursor-pointer"}>
          <PaginationNext
            onClick={(e) => {
              e.preventDefault();
              if (current_page < last_page) onPageChange(current_page + 1);
            }}
          />
        </PaginationItem>
      </PaginationContent>
    </Pagination>
  );
}

export default PaginationComponent;
